export default __webpack_public_path__ + "static/media/rating_5.82f6a6f8.png";